import { v1 as UUID } from "uuid";
// 问题类：单选、多选、判断
let Option = function(labelName) {
	this.oid = UUID();
    this.labelName = labelName || '';
    this.haveInput = false
    this.inputValue = ''
    this.decimalPlaces = 0
    this.format = 0 // 输入框格式
    this.minNum = 0
    this.maxNum = 0
    this.notAnswer = false
    this.isDefault = true // 标识为默认选项
}

export default Option;